import { FaCheckCircle, FaBan, FaFileInvoiceDollar } from 'react-icons/fa';
import { proformaStateLabel } from '@/lib/proformaState';
import { InvoiceStatus } from '../../types';

interface StatusBadgeProps {
  status: InvoiceStatus;
  size?: 'sm' | 'md' | 'lg';
  clickable?: boolean;
  onClick?: () => void;
}

export const getStatusIcon = (
  status: InvoiceStatus,
  size?: number,
  monochrome?: boolean,
) => {
  const iconSize = size || 12;

  // If monochrome is true, don't set color (inherit from parent)
  const getIconColor = (defaultColor: string) =>
    monochrome ? undefined : defaultColor;

  switch (status) {
    case InvoiceStatus.PAID:
      return (
        <FaCheckCircle
          color={getIconColor('var(--mantine-color-gray-7)')}
          size={iconSize}
        />
      );
    case InvoiceStatus.ISSUED:
      return (
        <FaFileInvoiceDollar
          color={getIconColor('var(--mantine-color-gray-6)')}
          size={iconSize}
        />
      );
    case InvoiceStatus.CANCELLED:
      return (
        <FaBan
          color={getIconColor('var(--mantine-color-gray-7)')}
          size={iconSize}
        />
      );
    default:
      return null;
  }
};

export const getStatusColor = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.PAID:
      return 'green';
    case InvoiceStatus.ISSUED:
      return 'gray';
    case InvoiceStatus.CANCELLED:
      return 'red';
    default:
      return 'gray';
  }
};

export const getStatusLabel = (status: InvoiceStatus | string) =>
  proformaStateLabel(status);

export function StatusBadge({
  status,
  size = 'md',
  clickable = false,
  onClick,
}: StatusBadgeProps) {
  const iconSize = size === 'sm' ? 12 : size === 'lg' ? 16 : 14;

  return (
    <div
      onClick={clickable ? onClick : undefined}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        cursor: clickable ? 'pointer' : 'default',
        fontSize: size === 'sm' ? '12px' : size === 'lg' ? '16px' : '14px',
        color: getStatusColor(status),
      }}
    >
      {getStatusIcon(status, iconSize)}
      <span>{getStatusLabel(status)}</span>
    </div>
  );
}

export default StatusBadge;
